/*
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2024-04-16 15:01:31
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-04-29 11:05:02
 * @FilePath: \xyjh-web\src\request\orderRequest.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import axios from "axios";
import store from "@/store";
import config from "../config";
import { getToken, removeToken, removeUserInfo } from "@/utils/auth";
const orderBaseUrl = config.orderBaseUrl[process.env.NODE_ENV];
// const orderBaseUrl = config.orderBaseUrl["development"];

const orderService = axios.create({  baseURL:orderBaseUrl, timeout: 15000 });

let isRefreshing = true; //防止并发请求时，重复提示登录

orderService.interceptors.request.use(
  (config) => {
    const requestTime = new Date(); // 记录请求时间
    let failureTime = Vue.prototype
      .$moment(requestTime)
      .diff(localStorage.requestTime, "hours", true);
    if (failureTime > 2) {
      if (isRefreshing) {
        isRefreshing = false;

        Vue.prototype
          .$confirm("登录已超时，请重新登录。", "温馨提示", {
            confirmButtonText: "确定",
            showClose: false,
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: "warning",
          })
          .then(() => {
            isRefreshing = true;
          })
          .catch(() => {
            isRefreshing = true;
          });
        store.commit("user/LOGOUT");
      }
    }
    if (store.getters.token) {
      config.headers["Authorization"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }

    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

orderService.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (
      response.status === 401 ||
      res.code === 20002 ||
      res.code === 401 ||
      res.code === 5000 ||
      res.code > 50000
    ) {
      return Promise.reject("error");
    } else {
      return response.data;
    }
  },
  (error) => {
    console.log("err" + error);
    return Promise.reject(error);
  }
);

export default orderService;
